import { createFileRoute } from '@tanstack/react-router';

import { crownQueryClient } from '@/common/api/crownQueryClient';
import { getCustomerQuery } from '@/features/administrator-panel/customer-view/api/customerViewApi';
import { fullName } from '@/lib/fullName';
import { CustomerView } from '@/features/administrator-panel/customer-view/CustomerView.tsx';

import { CustomerPreview } from '@/components/ui/route-previews/previews/CustomerPreview.tsx';

export const Route = createFileRoute('/admin/customers/$userId')({
  loader: ({ params }) =>
    crownQueryClient.ensureQueryData(getCustomerQuery(params.userId)),
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData
          ? fullName(loaderData.individual)
          : 'Customer Profile',
      },
    ],
  }),
  component: CustomerView,
  staticData: {
    previewComponent: CustomerPreview
  }
});
